import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import UserLayout from "./layouts/User";
import AdminLayout from "./layouts/Admin";
import AuthLayout from "./layouts/Auth";
import IndexView from "./views/Index";

import connect from 'redux-connect-decorator';
import { getUserInfo } from './actions/authActions';

@connect(
  state => ({
    auth: state.auth,
    loading: state.auth.loading,
    isAuthenticated: state.auth.isAuthenticated
  }),
  {
    getUserInfo
  }
)
export class App extends React.Component<any, any> {
  componentDidMount() {
    this.props.getUserInfo();
  }

  render() {
    return (
      // <Recorder />
      <BrowserRouter>
        <Switch>
          <Route path="/user" render={props => <UserLayout {...props} />} />
          <Route path="/admin" render={props => <AdminLayout {...props} />} />
          <Route path="/auth" render={props => <AuthLayout {...props} />} />
          <Route path="/" render={props => <IndexView {...props} />} />
          <Redirect from="*" to="/" />
        </Switch>
      </BrowserRouter>
    );
  }
}

// const mapStateToProps = ({ authentication, applicationProfile, locale, app }: IRootState) => ({
//   currentLocale: locale.currentLocale,
//   isAuthenticated: authentication.isAuthenticated,
//   isAdmin: hasAnyAuthority(authentication.account.authorities, [AUTHORITIES.ADMIN]),
//   ribbonEnv: applicationProfile.ribbonEnv,
//   isInProduction: applicationProfile.inProduction,
//   isSwaggerEnabled: applicationProfile.isSwaggerEnabled,
//   isSidebarOpen: app.isExpandedSidebar
// });

// const mapDispatchToProps = { setLocale, getSession, extendMenu };

// type StateProps = ReturnType<typeof mapStateToProps>;
// type DispatchProps = typeof mapDispatchToProps;

export default App;
